import React from 'react';

import type { StarsCoinReward } from '@swf/core/types/StarsCoinReward';

import styles from './StarsRewardList.scss';
import RewardStoreTile from './components/RewardStoreTile/RewardStoreTile';

interface Props {
  rewards: StarsCoinReward[];
  showCollect?: boolean;
}

const StarsRewardList: React.FC<Props> = ({ rewards, showCollect }) => (
  <ul className={styles.list}>
    {rewards.map((reward, index) => (
      <RewardStoreTile key={index} reward={reward} showCollect={!!showCollect} />
    ))}
  </ul>
);

export default StarsRewardList;
